export function Pagination({ data, page, setPage }) {

  const total = data.estimatedTotalHits || 0;
  const limit = 9;
  const totalPages = Math.ceil(total / limit);

  if (totalPages <= 1) return null;

  function scrollToBills() {

    const container = document.querySelector('#billTop');

    if (!container) return;

    const headerOffset = 80; // adjust for sticky header
    const elementPosition = container.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  function goToPage(p) {
    if (p < 1 || p > totalPages) return;
    setPage(p);
    setTimeout(() => {
      scrollToBills();
    }, 150)
  }

  const pages = [];

  let start = Math.max(1, page - 1);
  let end = Math.min(totalPages, page + 1);

  // Near the beginning
  if (page <= 2) {
    start = 1;
    end = Math.min(3, totalPages);
  }

  // Near the end
  if (page >= totalPages - 1) {
    start = Math.max(1, totalPages - 2);
    end = totalPages;
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div className="bill-nav">

      {/* Prev */}
        <button
          disabled={page === 1}
          onClick={() => goToPage(page - 1)}
        >
          &lt;
        </button>

      {/* First page + left ellipsis */}
      {start > 1 && (
        <>
            <button
              disabled={page === 1}
              className={page === 1 ? "active" : ""}
              onClick={() => goToPage(1)}
            >
              1
            </button>

          {start > 2 && <span className="ellipsis">…</span>}
        </>
      )}

      {/* Middle window */}
      {pages.map((p) => (
          <button
            disabled={page === p}
            className={page === p ? "active" : ""}
            onClick={() => goToPage(p)}
          >
            {p}
          </button>
      ))}

      {/* Right ellipsis + last page */}
      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="ellipsis">…</span>}

            <button
              disabled={page === totalPages}
              className={page === totalPages ? "active" : ""}
              onClick={() => goToPage(totalPages)}
            >
              {totalPages}
            </button>
        </>
      )}

      {/* Next */}
        <button
          disabled={page === totalPages}
          onClick={() => goToPage(page + 1)}
        >
          &gt;
        </button>

    </div>
  );
}